// src/GenerateLayout.js
import React from 'react';
import Sidebar from './Sidebar';
import './GenerateLayout.css';

function GenerateLayout({ children, onLoadPresentation,onNewChat }) {
  return (
    <div className="generate-layout">
      <Sidebar onLoadPresentation={onLoadPresentation}
       onNewChat={onNewChat} />
      <div className="generate-content">
        {children}
      </div>
    </div>
  );
}

export default GenerateLayout;